import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsBoxModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';
import { UseConsent } from '../../composables/consent.composable';
import { ConsentType } from '../../model/consent-checkbox';
import { ConsentBoxContainer } from '../consent-box/consent-box.container';

@Component({
  selector: 'cdf-consent-boxes',
  imports: [ConsentBoxContainer, DsBoxModule],
  template: `
    <div class="grid">
      <!-- NSC consents -->
      <cdf-consent-box-container
        [customerLanguage]="customerLanguage()"
        [consentCheckboxGroups]="consent().nsc.consentCheckboxes()"
        [legalText]="consent().nsc.legalText()"
        [(consentSelection)]="consent().nsc.consentSelection"
        [consentSelectionError]="consent().nsc.consentSelectionError()"
        [canSave]="consent().nsc.canBeSaved()"
        [isSaving]="consent().nsc.consentsAreSaving()"
        [initialConsentCreationMode]="consent().nsc.noConsentAvailable()"
        [missingRegistration]="!gcid()"
        [onlyImplicitConsentsSelected]="consent().nsc.onlyImplicitConsentsSelected()"
        [readonly]="readonly()"
        [consentSaveDate]="consent().nsc.consentSaveDate()"
        (confirm)="consent().nsc.saveConsent()"
        (copyConsent)="consent().copyConsent()"
      />

      @if (consent().dealer.showConsent()) {
        <!-- Dealer consents -->
        <cdf-consent-box-container
          [customerLanguage]="customerLanguage()"
          [consentCheckboxGroups]="consent().dealer.consentCheckboxes()"
          [legalText]="consent().dealer.legalText()"
          [consentSelection]="consent().dealer.consentSelection()"
          (consentSelectionChange)="consent().dealer.updateConsents($event)"
          [consentSelectionError]="false"
          (dealerLegalEntitiesSelectionChange)="consent().dealer.updateLegalEntities($event)"
          [dealerMandatoryLegalEntities]="consent().dealer.mandatoryLegalEntities()"
          [canSave]="consent().dealer.canBeSaved()"
          [isSaving]="consent().dealer.consentsAreSaving()"
          [initialConsentCreationMode]="consent().dealer.zeroConsentsAvailable()"
          [consentType]="ConsentType.DEALER"
          [consentSaveDate]="consent().dealer.consentSaveDate()"
          [readonly]="readonly()"
          (confirm)="consent().dealer.saveConsent()"
        />
      }
    </div>
  `,
  styleUrl: './consent-boxes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentBoxesComponent {
  protected readonly i18n = useI18n();

  readonly gcid = input.required<string | undefined>();
  readonly customerLanguage = input.required<string | undefined>();
  readonly readonly = input(false);

  readonly consent = input.required<UseConsent>();

  readonly ConsentType = ConsentType;
}
